export const POST_PROJECT_SEARCH_KEY = 'ProjectSearch';
